import SubscriptionShineIcon from "@svg/new-design/SubscriptionShineIcon";
import { FC, ReactNode } from "react";

const SubscriptionIconParent: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="w-full flex items-center justify-center">
      <div className="relative">
        <div className="absolute -bottom-1 -right-1 h-3 w-3">
          <SubscriptionShineIcon className="h-full w-full" aria-hidden="true" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default SubscriptionIconParent;
